export default __webpack_public_path__ + "static/img/vogue_test_scene_1_0031.376bf08.webp";